import { getCompanyDetails, getSucursalDetails } from "../../../../../services/datosEmpresa";
import { openCloseToast } from "../../../../Global/actions";

export const loading = (isLoading) => ({
  type: "LOADING_DATOS_EMPRESA",
  isLoading,
});

export const setCompanyData = (data) => ({
  type: "SET_COMPANY_DATA",
  data,
});

export const setSucursalData = (data) => ({
  type: "SET_SUCURSAL_DATA",
  data,
});

export const doGetCompanyData = (companyRut) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getCompanyDetails(companyRut);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        dispatch(setCompanyData(result.DetalleEmpresa));
      }
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetSucursalData = (companyRut, sucursalId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getSucursalDetails(companyRut, sucursalId);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        dispatch(setSucursalData(result.DetalleSucursal));
      }
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};
